<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oEyCAC/tc-custom/9781429946643.jpg?1737764323726" alt="This image is the cover for the book The Hanged Man"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Hanged Man
      </h1>
      <p class="bookDescription body article font2">
        <b>“Murder, mayhem and tea—a well-bred Victorian urban fantasy thriller. Prepare, o reader, to be enthralled.” —Patricia Briggs, #1 <i>New York Times</i>–bestselling author</b><br/><br/>On a freezing Christmas Eve in 1879, a forensic psychic reader is summoned from her Baker Street lodgings to the scene of a questionable death. Alexandrina Victoria Pendlebury (named after her godmother, the current Queen of England) is adamant that the death in question is a magically compromised murder and not a suicide, as the police had assumed, after the shocking revelation contained by the body in question, Alex must put her personal loss aside to uncover the deeper issues at stake, before more bodies turn up.<br/><br/>Turning to some choice allies—the handsome, prescient Lieutenant Brooks, the brilliant, enigmatic Lord Desmond, and her rapscallion cousin James—Alex will have to marshal all of her magical and mental acumen to save Queen and Country from a shadowy threat. Our singular heroine is caught up in this rousing gaslamp adventure of cloaked assassins, meddlesome family, and dark magic.<br/><br/><b>“With enough steampunk touches to satisfy, the real appeal here is the unconventional heroine, who defies propriety when needed but still likes a good cup of tea. Elrod, author of the Vampire Files series of supernatural mysteries returns with what one hopes will be a long-running series.” —<i>Library Journal</i> (starred review)</b><br/><br/><b>“With gasp-inducing twists and turns, Alex’s adventures in alt-London artfully combine the mysteries of Arthur Conan Doyle with the strange delights of H.G. Wells. A robust and clever breakout novel.” —<i>Kirkus Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        P. N. Elrod
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42d99730